import { AnchorHTMLAttributes } from 'react';
import { siteUrl } from './site';
import './IconLink.css';

function destination(href: string = '') {
  if (/^mailto:/i.test(href)) return 'mail';
  try {
    const host = new URL(href).hostname.toLowerCase();
    if (host === 'github.com' || host === 'www.github.com') return 'github';
    if (host === 'youtu.be' || host === 'youtube.com' || host.endsWith('.youtube.com')) return 'youtube';
  } catch { /* Internal links keep their existing presentation. */ }
  return null;
}

export default function IconLink({ href, children, ...props }: AnchorHTMLAttributes<HTMLAnchorElement>) {
  const icon = destination(href);
  return <a href={href} {...props}>{icon && <span className={`destination-icon destination-icon-${icon}`} style={{ maskImage: `url(${siteUrl(`/images/link-icons/${icon}.svg`)})`, WebkitMaskImage: `url(${siteUrl(`/images/link-icons/${icon}.svg`)})` }} aria-hidden="true" />}{children}</a>;
}
